import { signinRedirect, getToken } from 'overrides/api';
import { applicationState } from 'shared/store/applicationState';

export type BlobType = {
    blob: Blob,
    fileName: string
}

export async function getAuthHeader() {
    const token = await getToken();

    return {
        Authorization: `Bearer ${ token }`
    }
}

const getHeaderValue = (headers: Headers, key: string) => {
    if (!headers) {
        return null;
    }

    var header = headers.get(key);

    if (!header) {
        return null;
    }

    if (header.indexOf("=") > -1) {
        return (header.split(";")[1].trim().split("=")[1]).replace(/"/g, '');
    } else {
        return (header.split("=")[1]).replace(/"/g, '');
    }
}

export const httpDownloadAs = async (
    url: string,
    method: string,
    data: any = null
): Promise<BlobType | null> => {
    const authHeaders = await getAuthHeader();

    var fetchParams = {
        method: method ?? "POST",
        headers: {
            "content-type": "application/json",
            "response-type": "application/*",
            "authorization": authHeaders.Authorization
        }
    } as any;

    if (data != null) {
        fetchParams = { ...fetchParams, body: JSON.stringify(data) };
    }

    const response = await fetch(url, fetchParams);

    if (response) {
        console.log(response);
        const blob = await response.blob();

        return {
            blob: blob,
            fileName: getHeaderValue(response.headers, "content-disposition") ?? "untitled.csv"
        };
    }

    return null;
};

export const httpPost = async<T>(request: string, data?: any): Promise<T> => http(request, 'POST', data);
export const httpGet = async<T>(request: string, data?: any): Promise<T> => http(request, 'GET');
export const httpPut = async<T>(request: string, data?: any): Promise<T> => http(request, 'PUT', data);
export const httpDelete = async<T>(request: string, data?: any): Promise<T> => http(request, 'DELETE', data);

export const http = async <T>(
    request: string,
    method: string,
    data?: any
): Promise<T> => {
    const response = await http_fetch(request, method, (data ? JSON.stringify(data) : null));

    const body = await response.json();

    return body;
};

export const http_fetch = async (
    request: string,
    method: string,
    data?: any
): Promise<Response> => {
    const authHeaders = await getAuthHeader();

    const response = await fetch(request, {
        method: method,
        headers: {
            "content-type": "application/json",
            "authorization": authHeaders.Authorization
        },
        body: data
    });

    if (response.status == 401) {
        applicationState.setUser(undefined);
        signinRedirect();
    }

    return response;
};